import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import styles from './BrandingBanner.scss';

const StyledSvgBranding = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
`;

const BrandingBanner = ({ logo, color, className, logoClassName, containerClassName }) => (
  <section className={className || styles.wrapper} style={{ backgroundColor: color }}>
    <StyledSvgBranding width="100" height="30" fill={color}>
      <rect width="100%" height="3.25rem" />
    </StyledSvgBranding>
    <div className={containerClassName || styles.container}>
      {logo?.url && <img className={logoClassName || styles.logo} src={logo.url} alt={logo.alt} />}
    </div>
  </section>
);

BrandingBanner.propTypes = {
  color: PropTypes.string.isRequired,
  logo: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  className: PropTypes.string,
  logoClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default BrandingBanner;
